export const getPageTitle = (title: string): string => {
  return `${title} | YallaCompare`;
};
